/**
 * @generated SignedSource<<46aaf98c7fe5f9fcbf890b27644f6f9d>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5

import type { ConcreteRequest } from 'relay-runtime';
export type useContentStatusContentStatusQuery$variables = {
  contentId: string;
};
export type useContentStatusContentStatusQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly status: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
};
export type useContentStatusContentStatusQuery = {
  response: useContentStatusContentStatusQuery$data;
  variables: useContentStatusContentStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "current",
          "draft",
          "archived"
        ]
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentStatusContentStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentStatusContentStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
    "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
    "metadata": {},
    "name": "useContentStatusContentStatusQuery",
    "operationKind": "query",
    "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
  }
};
})();

(node as any).hash = "42fd7c46b2fddcc220c48467ae805b6e";

export default node;
